// extracted by mini-css-extract-plugin
export var readonly = "_hi-1";
export var star = "_hi-0";